import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-12 sm:py-16" data-id="element-65" data-mp="26mw1o8xw9apy">
      <div className="mx-auto max-w-4xl" data-id="element-66" data-mp="22lasoyohdgl1">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-67" data-mp="22mlz769b92fu">
          From Clinical Uncertainty to Confidence in Every Consultation
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-ink/70 sm:text-lg" data-id="element-68" data-mp="2ucqe4peawx9o">
          Stop searching for answers across multiple guidelines and start following a Clinical Pathway
          designed to help you evaluate, treat, and follow up with patients with obesity in a clear,
          organized, evidence-based way.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 sm:gap-5" data-id="element-69" data-mp="19vaoz35pu9jr">
          <div className="rounded-3xl border border-alert/20 bg-white p-5" data-id="element-70" data-mp="174ujgnjrn126">
            <div className="flex items-center gap-2" data-id="element-71" data-mp="1c4gvwurrsd9x">
              <span className="rounded-full bg-alert/10 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-alert" data-id="element-72" data-mp="1c35uv2ppljmi">
                Before
              </span>
            </div>
            <ul className="mt-4 space-y-3.5" data-id="element-73" data-mp="132fz1z0g7t8s">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-74" data-mp="odtkw0mk57j5">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-75" data-mp="t5l1pjfwvyw3" />
                  <span className="text-[14px] font-medium leading-snug text-ink/75" data-id="element-76" data-mp="t7frbb24of6i">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-forest-mid/25 bg-forest-deep p-5" data-id="element-77" data-mp="jgb982h5oe7g">
            <div className="flex items-center gap-2" data-id="element-78" data-mp="5hbmj0d7e9dx">
              <span className="rounded-full bg-white/15 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-79" data-mp="af3lufg6gxs5">
                With the Clinical Pathway
              </span>
            </div>
            <ul className="mt-4 space-y-3.5" data-id="element-80" data-mp="27d0zfmn4f845">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-81" data-mp="23bpgfzyr5l4x">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-forest-bright" aria-hidden="true" data-id="element-82" data-mp="23c7b4s5rnraq" />
                  <span className="text-[14px] font-medium leading-snug text-white/90" data-id="element-83" data-mp="1yep81iefk6an">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-84" data-mp="2r21m146iz5sc">
          <CTAButton label="Start my Clinical Pathway today" sub="Instant access for only $27 USD · One-time payment" data-id="element-85" data-mp="2m26v50mr2g7a" />
          <div className="mt-5" data-id="element-86" data-mp="2h2u8afvvp94p">
            <Countdown data-id="element-87" data-mp="1ana4jmax3ixt" />
          </div>
        </div>
      </div>
    </section>;
}